import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

class GenericDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            header: this.props.header,
            content: this.props.content,
            isShowing: this.props.isShowing,
            showFooter: this.props.showFooter,
            showCloseButton: this.props.showCloseButton,
            onHide: this.props.onHide,
            buttons: this.props.buttons,
            renderButtons: ''
        };
    }

    componentWillReceiveProps(nextProps, nextState) {
        const renderButtons = nextProps.buttons.map(button => (
            <button
                type="button"
                className="btn btn-default btn-bordered std-button"
                onClick={button.onClick}
            >
                {button.text}
            </button>
        ));
        this.setState({
            header: nextProps.header,
            content: nextProps.content,
            isShowing: nextProps.isShowing,
            showFooter: nextProps.showFooter,
            showCloseButton: nextProps.showCloseButton,
            onHide: nextProps.onHide,
            buttons: nextProps.buttons,
            renderButtons: renderButtons
        });
    }

    render() {
        let {
            header,
            content,
            onHide,
            isShowing,
            buttons,
            showCloseButton
        } = this.props;

        return (
            <Modal show={isShowing} onHide={onHide}>
                <Modal.Header closeButton={showCloseButton}>
                    <Modal.Title>{header}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="form-modal">
                    <p>{content}</p>
                </Modal.Body>
                {buttons && (
                    <Modal.Footer>{this.state.renderButtons}</Modal.Footer>
                )}
            </Modal>
        );
    }
}

GenericDialog.propTypes = {
    header: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired,
    isShowing: PropTypes.bool.isRequired,
    showFooter: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    onHide: PropTypes.func,
    buttons: PropTypes.array
};

GenericDialog.defaultProps = {
    confirmButtonText: 'OK',
    cancelButtonText: 'Cancel',
    showFooter: true,
    showCloseButton: true,
    isShowing: false,
    buttons: [],
    onHide: () => {}
};

export default GenericDialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/GenericDialog.js